import React, { useMemo, useState } from 'react';
import { Modal } from '../../components/ui';
import { fullName } from '../../utils/helpers';

// Desktop "put this guest into a family": the same list in a normal dialog.
export default function JoinFamilyDesktop({ guest, families, onClose, onPick }) {
  const [q, setQ] = useState('');
  const shown = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return needle ? families.filter(f => f.label.toLowerCase().includes(needle)) : families;
  }, [families, q]);

  return (
    <Modal title={`Add ${fullName(guest)} to a family`} onClose={onClose}
      footer={<button className="btn light" onClick={onClose}>Cancel</button>}>
      {families.length === 0 ? (
        <div className="muted" style={{ fontSize: 13 }}>
          No families yet. “Create Family” on a guest makes that person the head of one.
        </div>
      ) : (
        <>
          <input placeholder="Search families…" value={q} onChange={e => setQ(e.target.value)}
            style={{ width: '100%', padding: 9, border: '1px solid var(--line)', borderRadius: 10, marginBottom: 10 }} />
          <div className="num-choice">
            {shown.map(f => (
              <button key={f.familyId} type="button" className="num-choice-row" onClick={() => onPick(f)}>
                <strong>{f.label}</strong>
                <span className="muted">{f.size} {f.size === 1 ? 'person' : 'people'}</span>
              </button>
            ))}
            {shown.length === 0 && <div className="muted" style={{ fontSize: 13 }}>No family matches “{q}”.</div>}
          </div>
        </>
      )}
    </Modal>
  );
}
